import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const api = axios.create({
  baseURL: BASE_URL,
  timeout: 20000, // l'upload d'un fichier peut prendre un moment
});

const authHeader = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

// ── Référentiels ────────────────────────────────────────────────
export const getDocumentTypes = (token) =>
  api.get('/api/documents/types', authHeader(token)).then(r => r.data);

export const getApplications = (token) =>
  api.get('/api/documents/applications', authHeader(token)).then(r => r.data);

export const getDocumentStatus = (token) =>
  api.get('/api/documents/status', authHeader(token)).then(r => r.data);

// ── Matrice d'accès par DOCUMENT (Administrateur ou plus) ───────
export const getDocumentAccess = (token) =>
  api.get('/api/documents/access', authHeader(token)).then(r => r.data);

export const setDocumentAccess = (token, documentId, niveaux) =>
  api.put(
    '/api/documents/access',
    { document_id: documentId, niveaux },
    authHeader(token)
  ).then(r => r.data);

// ── Liste des documents visibles par l'utilisateur connecté ─────
export const listDocuments = (token) =>
  api.get('/api/documents', authHeader(token)).then(r => r.data);

// ── Import d'un document (Super Administrateur uniquement) ──────
// file peut être null si docType est de type "lien" (ex: lien_crouzet_soft)
export const createDocument = (token, { docType, title, application, externalLink, file }, onProgress) => {
  const formData = new FormData();
  formData.append('doc_type', docType);
  formData.append('title', title);
  if (application) formData.append('application', application);
  if (externalLink) formData.append('external_link', externalLink);
  if (file) formData.append('file', file);

  return api.post('/api/documents', formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress: (event) => {
      if (!onProgress || !event.total) return;
      onProgress(Math.round((event.loaded * 100) / event.total));
    },
  }).then(r => r.data);
};

// ── Téléchargement protégé d'un fichier ──────────────────────────
export const getDocumentFileUrl = (token, docId) =>
  api.get(`/api/documents/${docId}/file`, {
    ...authHeader(token),
    responseType: 'blob',
  }).then(r => URL.createObjectURL(r.data));

// ── Suppression (Super Administrateur uniquement) ────────────────
export const deleteDocument = (token, docId) =>
  api.delete(`/api/documents/${docId}`, authHeader(token)).then(r => r.data);

// ── Extrait un message d'erreur lisible depuis une erreur axios ─
export const getErrorMessage = (error, fallback = "Une erreur est survenue.") =>
  error?.response?.data?.detail || fallback;
